import { TrendCardProps } from "../types";
import classes from "../PriceTrend.module.scss";
import InfoIcon from "@Icons/InfoIcon";
import Tooltip from "@Components/Tooltip/Tooltip";
import gtagEventEmitter from "helpers/gtagEventEmitter";
import { PAGE } from "constants/configConstants";
import ArrowUpIcon from "@Icons/ArrowUpIcon";
import theme from "@Theme/exportColor.module.scss";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import useIsDesktop from "hooks/useIsDesktop";

const TrendCard = ({ trend }: TrendCardProps) => {
  const { t } = useTranslationHook();
  const isDesktop = useIsDesktop();
  if (!trend?.isCardVisible) {
    return <></>;
  }
  const isGreen = trend.id === 1 || trend.id === 2 || trend.value < 0;

  return (
    <div
      data-testid="property-price-trend-container-info"
      className={formatClassNames(classes.trendCard, isDesktop && classes.desktop)}
    >
      <div className={classes.trendTopSection}>
        <div className={classes.flexApart}>
          <div data-testid="property-price-trend-container-title" className={classes.terndTitle}>
            {t(trend?.title)}
          </div>
          <Tooltip className={classes.tooltip} content={t(trend?.tooltip)} direction="bottom">
            <div
              onMouseEnter={() =>
                gtagEventEmitter({
                  action: "Tooltip_Opened",
                  category: PAGE.INVENTORY,
                  label: `Price Trend Insight ${trend?.id} Tooltip`,
                })
              }
            >
              <div className={classes.tooltipInnerClass}>
                <InfoIcon height="16" width="16" />
              </div>
            </div>
          </Tooltip>
        </div>
        <div className={classes.flexStart}>
          {trend?.id !== 1 &&
            (isGreen ? <ArrowUpIcon rotate={180} fill={theme.secondary5} /> : <ArrowUpIcon />)}
          <div
            data-testid="property-price-trend-container-trending-property-value"
            className={classes.trendValue}
            style={{
              color: isGreen ? theme.secondary5 : theme.danger5,
            }}
          >
            {trend?.valuePrefix + Math.abs(trend?.value).toFixed(2) + trend?.valueSuffix}
          </div>
        </div>
      </div>
      {isDesktop && <div className={classes.divider} />}
      <div data-testid="property-price-trend-container-info" className={classes.trendCardText}>
        {trend?.subText}
      </div>
    </div>
  );
};

export default wrapperHOC(TrendCard, {
  componentName: "TrendCard-PriceTrends-PropertyPage",
  showForChina: true,
});
